import React from "react";
import { mountBrowserRoot } from './mountBrowserRoot';
import "@/index.css";
import App from "@/App";

/* v3.14.11 — Suppress runtime-error overlay noise from browser
 * extensions. Wallet extensions (MetaMask, Coinbase Wallet,
 * Phantom, Rabby, etc.) inject scripts into every page and freely
 * throw unhandled promise rejections when their connection
 * preconditions aren't met. CRA's dev error overlay catches every
 * unhandledrejection on window, so a merchant with MetaMask
 * installed sees a giant red wall on every load even though it's
 * not our code.
 *
 * We swallow ONLY errors whose stack frames trace back to
 * chrome-extension:// / moz-extension:// / safari-extension://
 * URLs. Real app errors still flow through to the overlay and
 * Sentry/logging.
 */
const EXTENSION_URL_RE = /\b(chrome|moz|safari|edge)-extension:\/\//i;
const isFromExtension = (reasonOrError) => {
  if (!reasonOrError) return false;
  const stack = (reasonOrError.stack || reasonOrError.message || String(reasonOrError));
  return EXTENSION_URL_RE.test(stack);
};

window.addEventListener("unhandledrejection", (event) => {
  if (isFromExtension(event.reason)) {
    event.preventDefault();
  }
});

window.addEventListener("error", (event) => {
  if (
    (event.filename && EXTENSION_URL_RE.test(event.filename)) ||
    isFromExtension(event.error)
  ) {
    event.preventDefault();
  }
}, true);

mountBrowserRoot(document.getElementById("root"),
  <React.StrictMode>
    <App />
  </React.StrictMode>,
).catch(error => {
  // Keep the static content and native links usable if the chunk fails to load.
  console.error('PlateOS page interactions could not load', error);
  const notice = document.createElement('p');
  notice.setAttribute('role', 'alert');
  notice.textContent = 'Page interactions could not load. Please reload to try again.';
  document.getElementById('root').prepend(notice);
});
